"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import Script from "next/script";
import dynamic from "next/dynamic";
import Sticky from "react-stickynode";
import Modal from "react-modal";
import { useAppContext } from "@components/Provider";

import {
  _formatDate,
  formatCategory,
  RenderArticleSchema,
  RenderBreadCrumbSchema,
  formatImageUrlByDevice,
} from "../../../../src/helpers/Helper";
import Sites from "../../../../src/constants/Sites";
import PostTypes from "../../../../src/constants/Post";
import Device from "../../../../src/constants/Device";
import EBBHomepage from "@components/HomePage/EBBHomepage";
import PostImage from "../../../../src/components/PostImage/PostImage";
import BreadCrumb from "@components/BreadCrumb/BreadCrumb";

import styles from "./Post.module.css";
import "./Post.css";

//Dynamic loading of component, it will force component to load as separate chunks also
const SocialShareButtons = dynamic(
  () => import("../../../../src/components/SocialShareButtons/SocialShareButtons")
);

const PubExchangeWidget = dynamic(
  () => import("../../../../src/components/PubExchange/PubExchangeWidget")
);

const DealsPageNew = dynamic(() => import("../../../../app/deals/[slug]/DealsPageNew"));
const RenderTags = dynamic(() => import("../../../../src/components/Tags/Tags"));
const GiveAwayPage = dynamic(() => import("../../../../src/components/GiveAwayPage/GiveAwayPage"));

const Page = dynamic(() => import("../../../../src/components/Page/Page"));
const Funnel = dynamic(() => import("../../../../src/components/Funnel/Funnel"));
const PageBuilder = dynamic(() => import("../../../../src/helpers/PageBuilder"));
const CategoryFunnel = dynamic(
  () => import("../../../../src/components/CategoryFunnel/CategoryFunnel")
);
const InterestPage = dynamic(() => import("../../../../src/components/InterestPage/InterestPage"));

const customStyles = {
  // content:  {
  //   // position: 'fixed',
  //   // top: '75%',
  //   // left: '80%',
  //   // right: 'auto',
  //   // bottom: 'auto',
  //   // marginRight: '-50%',
  //   // transform: 'translate(-50%, -50%)',
  //   // //border: '1px solid #ccc',
  //   // background: 'black',
  //   // width: 450,
  //   // height:200,
  // },
  overlay: {
    top: "75%",
    left: "80%",
    right: "auto",
    bottom: "auto",
    margin: "0 20px",
    marginRight: "-20%",
    transform: "translate(-50%, -50%)",
    border: "1px solid #ccc",
    background: "black",
    width: 450,
    height: 200,
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px",
    // 'max-width': '34%'
  },
};
const Post = (props) => {
  const data = (props && props.data && props.data) || [];
  let { isMobile, isTablet, siteId } = props;
  const post = (data && data[0]?.Post?.post) || {};
  const Recommendation =
    (data[1] &&
      data[1].Recommendation &&
      data[1].Recommendation.content &&
      data[1].Recommendation.content) ||
    {};
  const [showModal, setShowModal] = useState(false);
  const { updatePageViews } = useAppContext();
  useEffect(() => {
    if (
      Number(post?.post_type) !== PostTypes.TYPES.EBB_HOMEPAGE &&
      process.env.ENABLE_READNEXT === "true"
    ) {
      //Observe Tag for DIV to show/hide read next modal
      const tag = document.querySelector("#dvtag");
      if (tag) {
        let observer = new IntersectionObserver((entries) => setShowModal(entries[0].isIntersecting));
        observer.observe(tag);
        Modal.setAppElement("#modals");
      }
    }
    updatePageViews();
  }, []);
  const renderPromoted = (promoted) => {
    return <span className={styles.promoted}>Promoted by {promoted}</span>;
  };

  const renderByline = (authorByline) => {
    const bylineArray = [];
    let seperator = "";
    authorByline &&
      authorByline.length > 0 &&
      authorByline.map((byline) => {
        if (byline && byline.display_name != "") {
          bylineArray.push(byline.display_name);
        }
      });
    return bylineArray.length > 0
      ? bylineArray.map((byline, i) => {
          if (i > 0 && i === bylineArray.length - 1) {
            seperator = " & ";
          } else {
            if (i) {
              seperator = ", ";
            }
          }
          return (
            byline && (
              <span key={i}>
                {seperator}
                <Link href={"/author/" + encodeURIComponent(byline)}>{byline}</Link>
              </span>
            )
          );
        })
      : "";
  };
  const renderPage = () => {
    const { data, siteId, host } = useAppContext() || {};
    const { SiteSettings } = data || {};
    const pageBuilderOptions = {
      Newsletter_Settings: {
        ...SiteSettings.newsletter_settings,
      },
      slug: props.slug,
      postType: post?.post_type,
    };
    const pubexchangeSetting = SiteSettings.pubexchange_setting || null;
    const lede = post?.lede;
    const date =
      post?.originalpub_date &&
      post?.originalpub_date !== null &&
      _formatDate(post.originalpub_date, "MMM d, yyyy");
    const updatedOn = post?.published_on && _formatDate(post.published_on, "MMM d, yyyy");
    const promoted = post?.promoted ? renderPromoted(post.promoted) : null;
    const domain = host;
    const categoryUrl =
      post?.categories?.length !== 0 && post?.categories[0]
        ? encodeURI(domain + `/category/${formatCategory(post?.categories[0], true).toLowerCase()}`)
        : "";
    const socialImage =
      post?.featured_media?.name &&
      formatImageUrlByDevice(post.featured_media.name, isMobile ? Device.PHONE : Device.DESKTOP);
    const socialShareButtons = (
      <SocialShareButtons
        siteId={siteId}
        pageUrl={props.asPath}
        isMobile={isMobile}
        socialImage={socialImage}
      />
    );
    let adNetwork = "adsense";

    if (SiteSettings?.ad_settings?.adnetwork) {
      adNetwork = SiteSettings.ad_settings.adnetwork;
    }

    const authorLinks = post?.byline && renderByline(post.byline);

    let updatedDate =
      date === false || new Date(updatedOn).getTime() <= new Date(date).getTime() || !date ? (
        ""
      ) : (
        <>Updated {updatedOn}</>
      );

    const closeModal = () => setShowModal(false);

    const buildReadNext = () => {
      if (Recommendation && Recommendation.length > 0) {
        return (
          <div>
            <Modal
              isOpen={showModal}
              onRequestClose={closeModal}
              className={"newsletter-modal autoPopUp"}
              style={customStyles}
              contentLabel="Read Next"
            >
              <h2 className="plain">READ NEXT</h2>
              <div className={styles["readnext"]}>
                <Link href={`${Recommendation[0].url}?utm=read-next`}>
                  <p
                    className="plain"
                    dangerouslySetInnerHTML={{
                      __html: Recommendation[0].title,
                    }}
                  />
                </Link>
              </div>
            </Modal>
          </div>
        );
      }
    };

    return (
      <React.Fragment>
        {!isMobile && (
          <Sticky enabled={true} top={300} bottomBoundary={".empty"}>
            {socialShareButtons}
          </Sticky>
        )}
        <div
          className={
            isMobile
              ? [styles["SingleArticlePage"], "SingleArticlePage", "topPadding"].join(" ")
              : [styles["SingleArticlePage"], "SingleArticlePage"].join(" ")
          }
          style={{
            "--single-article-h1-font": siteId === Sites.THEPORTALIST ? "14pt" : "24pt",
            "--single-article-info-font": siteId === Sites.THEPORTALIST ? "10pt" : "14px",
            "--single-article-p-font": siteId === Sites.THEPORTALIST ? "14px" : "15px",
          }}
        >
          <>
            {post?.categories?.length > 0 && (
              <BreadCrumb categories={post?.categories} isMobile={isMobile} />
            )}
            <>
              <h1 dangerouslySetInnerHTML={{ __html: post?.title }} />
              <p
                className={styles["post-subtitle"]}
                dangerouslySetInnerHTML={{ __html: post?.sub_title }}
              />
            </>
            {authorLinks || updatedDate ? (
              <div className={[styles["single-article-info"], "single-article-info"].join(" ")}>
                {promoted}
                {promoted && (authorLinks || updatedDate) ? (
                  <span className="separator"> | </span>
                ) : null}
                {authorLinks ? "By" : null} {authorLinks}
                {isMobile ? (
                  <br />
                ) : (
                  authorLinks && updatedDate && <span className="separator"> | </span>
                )}
                <span className={isMobile ? styles["DateMobile"] : styles["Date"]}>
                  {updatedDate}
                </span>
                {isMobile
                  ? updatedDate && date && <span className="separator"> | </span>
                  : (authorLinks || updatedDate) && date && <span className="separator"> | </span>}
                {
                  <span className={isMobile ? styles["DateMobile"] : styles["Date"]}>
                    Published{" "}
                    {date
                      ? date
                      : '"Date Is Assigned When The Post Is Published For The First Time"'}
                  </span>
                }
                <div className={styles.mobileSocialShare}>{socialShareButtons}</div>
              </div>
            ) : (
              ""
            )}
            <div className={styles["singleArticleHero"]}>
              <PostImage
                {...post?.featured_media}
                size={isMobile ? Device.PHONE : Device.DESKTOP}
                key={post?.featured_media?.Name || post?.featured_media?.name || "featured"}
                width="757"
                height="320"
                isLazyLoading={false}
                className="postImage"
                isFeaturedImage={true}
                isMobile={props.isMobile}
              />
            </div>
            <div className={"single-article-body"}>
              {/* Additional class layout_v2 so SheKnows can understand it is new layout and do not add auto ad. Don't delete it */}
              <div className="single-article-center layout_v2">
                {post?.post_type != PostTypes.TYPES.PAGE ? (
                  <div className="Lede" dangerouslySetInnerHTML={{ __html: lede }} />
                ) : null}
                <PageBuilder
                  post={post}
                  pageBuilderOptions={pageBuilderOptions}
                  siteId={props.siteId}
                  isMobile={isMobile}
                  isTablet={isTablet}
                  adNetwork={adNetwork}
                  pageUrl={props.pageUrl}
                />
                <div className={styles["tagsContainer"]} id="dvtag">
                  <RenderTags tags={post?.tags} />
                </div>
                {process.env.ENABLE_READNEXT === "true" && (
                  <div className="readnext-test" id="modals">
                    {buildReadNext()}
                  </div>
                )}
                <div className="empty"></div>
                {pubexchangeSetting &&
                (post?.adSettings?.removePubExchange === undefined ||
                  post?.adSettings?.removePubExchange === false) ? (
                  <PubExchangeWidget pubexchangeSetting={pubexchangeSetting} />
                ) : null}
              </div>
            </div>

            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={RenderArticleSchema(post, SiteSettings, host)}
            />
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={RenderBreadCrumbSchema(host, categoryUrl, post?.title)}
            />
            {post?.adSettings?.removeAds ? (
              <Script
                strategy="lazyOnload"
                type="text/javascript"
                data-cfasync="false"
                dangerouslySetInnerHTML={{
                  __html: `
              var blogherads = blogherads || {};
              blogherads.adq = blogherads.adq || [];
              blogherads.adq.push(function() {
              blogherads.disableAds();
              });
            `,
                }}
              />
            ) : null}
          </>
        </div>
      </React.Fragment>
    );
  };
  switch (post?.post_type) {
    case PostTypes.TYPES.DEALS:
    case PostTypes.TYPES.LANDING_DEALS:
    case PostTypes.TYPES.YOUNG_BOOK_READER:
    case PostTypes.TYPES.KINDLE_UNLIMITED_DEALS:
      // Use DealsWrapper component to fetch enriched data
      return <DealsWrapper post={post} siteId={siteId} data={data} props={props} styles={styles} />;
    case PostTypes.TYPES.GIVEAWAY_PAGE:
      return <GiveAwayPage {...props} />;
    case PostTypes.TYPES.PAGE:
      return <Page {...props} />;
    case PostTypes.TYPES.FUNNEL:
      return <Funnel {...props} />;
    case PostTypes.TYPES.CATEGORY_FUNNEL:
      return <CategoryFunnel {...props} />;
    case PostTypes.TYPES.EBB_HOMEPAGE:
      return <EBBHomepage {...props} />;
    case PostTypes.TYPES.INTEREST_PAGE:
      return <InterestPage {...props} />;
    default:
      return <React.Fragment>{renderPage()}</React.Fragment>;
  }
};

// Wrapper component to format initial data for DealsPageNew
const DealsWrapper = ({ post, data, props, styles }) => {
  const pageSize = 20;
  const currentPage = props.pageNumber || 1;
  const totalComponents = post?.componentsCount || post?.components?.length || 0;
  const totalPages = Math.ceil(totalComponents / pageSize) || 1;

  const postData = {
    post: {
      ...post,
      components: (post?.components || []).slice(0, pageSize), // Only first page for initial load
      componentsCount: totalComponents,
    },
    totalPages,
    pageSize,
    currentPage,
  };

  // Prepare filters
  const customCatagoriesFromData = data[0]?.Post?.customCatagories || [];
  let filters = { customCatagories: customCatagoriesFromData };

  if (props.filters) {
    if (typeof props.filters === "object" && !Array.isArray(props.filters)) {
      filters = {
        ...props.filters,
        customCatagories: props.filters.customCatagories || customCatagoriesFromData,
      };
    } else if (Array.isArray(props.filters)) {
      filters = { customCatagories: props.filters };
    }
  }

  return (
    <div className={`deals-page-wrapper ${styles.dealsPageFullWidth}`}>
      <DealsPageNew postData={postData} filters={filters} />
    </div>
  );
};

export default Post;
